import LoadPanel from 'devextreme/ui/load_panel';
import type dxLoadPanel from 'devextreme/ui/load_panel';

let loadPanelInstance: dxLoadPanel | null = null;
let containerEl: HTMLDivElement | null = null;

function ensureLoadPanel(): dxLoadPanel {
  if (!loadPanelInstance) {
    containerEl = document.createElement('div');
    document.body.appendChild(containerEl);
    loadPanelInstance = new LoadPanel(containerEl, {
      shading: true,
      showIndicator: true,
      showPane: true,
      hideOnOutsideClick: false,
      delay: 0
    });
  }
  return loadPanelInstance;
}

function resolvePositionTarget(preferredSelector: string): Element | Window {
  return document.querySelector(preferredSelector) ?? window;
}

export async function withLoadingPanel<T>(
  message: string,
  action: () => Promise<T>,
  options?: { positionOf?: string }
): Promise<T> {
  const panel = ensureLoadPanel();
  panel.option({
    message,
    position: { of: resolvePositionTarget(options?.positionOf ?? '.file-browser-host') }
  });
  panel.show();
  try {
    return await action();
  } finally {
    panel.hide();
  }
}
